

import { Navigate, useLocation } from "react-router-dom";
import { getAllowedRoutes } from "./getAllowedRoutes";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase();

  const user = sessionStorage.getItem("user");
  const power = sessionStorage.getItem("power");

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (power === null) {
    return null;
  }

  if (power !== "1") {
    if (!currentPath.startsWith("/profile/plans")) {
      return <Navigate to="/Profile/Plans" replace />;
    }
    return children;
  }

  const entitlement = JSON.parse(sessionStorage.getItem("entitlement")) || [];

  const allowedRoutes = getAllowedRoutes(entitlement);

  if (currentPath === "/dashboard") {
    return children;
  }

  if (!allowedRoutes.length) {
    return <Navigate to="/dashboard" replace />;
  }

  const isAllowed = allowedRoutes.some((route) => {
    return currentPath === route || currentPath.startsWith(route + "/");
  });

  if (!isAllowed) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
